"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import type { BaseProviderFormProps } from "@/components/settings/data-providers/provider-forms/base-provider-form";
import { InstructionsWrapper } from "@/components/settings/data-providers/provider-forms/instructions-wrapper";
import { FormInput } from "@/components/ui/input";
import { FormPasswordInput } from "@/components/ui/password-input";
import { FormMultiSelect } from "@/components/ui/select";
import { createCondition, WithCondition } from "@/components/ui/with-condition";
import { ProviderType } from "@/types/dataProvider";
export const AppFolioReportingApiProviderForm = t0 => {
  const $ = _c(59);
  const {
    form,
    isCreating,
    currentStep,
    providerData,
    isEditMode: t1
  } = t0;
  const isEditMode = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== providerData?.propertyGroupOptions) {
    t2 = providerData?.propertyGroupOptions as {
      value: string;
      label: string;
    }[] || [];
    $[0] = providerData?.propertyGroupOptions;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const propertyGroupOptions = t2;
  let t3;
  if ($[2] !== form) {
    t3 = form.watch();
    $[2] = form;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const watchedValues = t3;
  const databaseName = (watchedValues.data.credentials as {
    databaseName: string;
  }).databaseName;
  const appfolioUrl = `https://${databaseName}.appfolio.com/api_credentials/basic_auth_credentials`;
  let t4;
  if ($[4] !== currentStep || $[5] !== isEditMode) {
    t4 = createCondition.or(createCondition.truthy(currentStep === 0), createCondition.truthy(isEditMode));
    $[4] = currentStep;
    $[5] = isEditMode;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <li>Go to your AppFolio dashboard.</li>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <li>Observing the URL in your browser (e.g:{" "}<code><u>companyx</u>.appfolio.com</code>).</li>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <code className="italic">.appfolio.com</code>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ol className="">{t5}{t6}<li>The prefix to {t7} is your database name - in this scenario,{" "}<strong><code>companyx</code></strong>.</li></ol>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== isEditMode) {
    t9 = <InstructionsWrapper accordion={isEditMode} title="How to find your AppFolio Database Name:">{t8}</InstructionsWrapper>;
    $[11] = isEditMode;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== form || $[14] !== isCreating) {
    t10 = <FormInput autoComplete="off" disabled={isCreating} form={form} label="Database Name" name="data.credentials.databaseName" placeholder="Enter Database Name (e.g. companyx)" type="text" />;
    $[13] = form;
    $[14] = isCreating;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t4 || $[18] !== t9) {
    t11 = <WithCondition condition={t4}>{t9}{t10}</WithCondition>;
    $[16] = t10;
    $[17] = t4;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== currentStep || $[21] !== isEditMode) {
    t12 = createCondition.or(createCondition.truthy(currentStep === 1), createCondition.truthy(isEditMode));
    $[20] = currentStep;
    $[21] = isEditMode;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== appfolioUrl) {
    t13 = <li>Go to your{" "}<a className="text-primary underline" href={appfolioUrl} rel="noopener noreferrer" target="_blank">AppFolio General Settings Page</a>{" "}and sign in if prompted.</li>;
    $[23] = appfolioUrl;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <u><strong>Reports API</strong></u>;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <li>If there are no credentials, click on the{" "}<u><strong>Generate New Credentials</strong></u>{" "}button to create new credentials.</li>;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <u><strong>Client ID</strong></u>;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  let t18;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <li>Under the{" "}{t14}{" "}section:<ul className="mt-2">{t15}<li>If there are credentials, copy the{" "}{t16}{" "}and{" "}<u><strong>Client Secret</strong></u>{" "}values into the fields below.</li></ul></li>;
    t18 = <li>Verify the credentials in the fields are the same as the ones you copied from AppFolio.</li>;
    $[28] = t17;
    $[29] = t18;
  } else {
    t17 = $[28];
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t13) {
    t19 = <ol className="">{t13}{t17}{t18}</ol>;
    $[30] = t13;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== isEditMode || $[33] !== t19) {
    t20 = <InstructionsWrapper accordion={isEditMode} title="How to find your AppFolio Connection Secrets:">{t19}</InstructionsWrapper>;
    $[32] = isEditMode;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  let t22;
  if ($[35] !== form || $[36] !== isCreating) {
    t21 = <FormInput autoComplete="off" disabled={isCreating} form={form} label="Client ID" name="data.credentials.clientId" placeholder="Enter new Client ID" type="text" />;
    t22 = <FormPasswordInput autoComplete="new-password" disabled={isCreating} form={form} label="Client Secret" name="data.credentials.clientSecret" placeholder="Enter new Client Secret" type="password" />;
    $[35] = form;
    $[36] = isCreating;
    $[37] = t21;
    $[38] = t22;
  } else {
    t21 = $[37];
    t22 = $[38];
  }
  let t23;
  if ($[39] !== t12 || $[40] !== t20 || $[41] !== t21 || $[42] !== t22) {
    t23 = <WithCondition condition={t12}>{t20}{t21}{t22}</WithCondition>;
    $[39] = t12;
    $[40] = t20;
    $[41] = t21;
    $[42] = t22;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== currentStep || $[45] !== isEditMode) {
    t24 = createCondition.or(createCondition.truthy(currentStep === 2), createCondition.truthy(isEditMode));
    $[44] = currentStep;
    $[45] = isEditMode;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      className: "w-full"
    };
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== form || $[49] !== isCreating || $[50] !== propertyGroupOptions) {
    t26 = <div className="mt-2"><FormMultiSelect disabled={isCreating} form={form} label="Property Groups" name={"data.propertyGroupIds" as any} options={propertyGroupOptions} placeholder="Select Property Groups" searchable={true} searchPlaceholder="Search property groups..." triggerProps={t25} /></div>;
    $[48] = form;
    $[49] = isCreating;
    $[50] = propertyGroupOptions;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] !== t24 || $[53] !== t26) {
    t27 = <WithCondition condition={t24}>{t26}</WithCondition>;
    $[52] = t24;
    $[53] = t26;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== t11 || $[56] !== t23 || $[57] !== t27) {
    t28 = <>{t11}{t23}{t27}</>;
    $[55] = t11;
    $[56] = t23;
    $[57] = t27;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  return t28;
};
export const AppFolioDatabaseApiProviderForm = t0 => {
  const $ = _c(39);
  const {
    form,
    isCreating,
    currentStep,
    isEditMode: t1
  } = t0;
  const isEditMode = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== currentStep || $[1] !== isEditMode) {
    t2 = createCondition.or(createCondition.truthy(currentStep === 1), createCondition.truthy(isEditMode));
    $[0] = currentStep;
    $[1] = isEditMode;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <li>Sign in to{" "}<a className="text-primary underline" href="https://developer.appfolio.com/" rel="noopener noreferrer" target="_blank">developer.appfolio.com</a>.</li>;
    t4 = <li>Open your Dashboard.</li>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <strong>Show</strong>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <li>Under your API application, click {t5} to reveal the <strong>Client ID</strong>.</li>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <strong>Regenerate</strong>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ol>{t3}{t4}{t6}<li>Click {t7} for the{" "}<strong>Client Secret</strong>.</li><li>Copy both values into the fields below.</li></ol>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== isEditMode) {
    t9 = <InstructionsWrapper accordion={isEditMode} title="How to find your AppFolio Database API credentials:">{t8}</InstructionsWrapper>;
    $[9] = isEditMode;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  let t11;
  if ($[11] !== form || $[12] !== isCreating) {
    t10 = <FormInput autoComplete="off" disabled={isCreating} form={form} label="Client ID" name="data.credentials.clientId" placeholder="Enter Client ID" type="text" />;
    t11 = <FormPasswordInput autoComplete="new-password" disabled={isCreating} form={form} label="Client Secret" name="data.credentials.clientSecret" placeholder="Enter Client Secret" type="password" />;
    $[11] = form;
    $[12] = isCreating;
    $[13] = t10;
    $[14] = t11;
  } else {
    t10 = $[13];
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10 || $[16] !== t11 || $[17] !== t2 || $[18] !== t9) {
    t12 = <WithCondition condition={t2}>{t9}{t10}{t11}</WithCondition>;
    $[15] = t10;
    $[16] = t11;
    $[17] = t2;
    $[18] = t9;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== currentStep || $[21] !== isEditMode) {
    t13 = createCondition.or(createCondition.truthy(currentStep === 2), createCondition.truthy(isEditMode));
    $[20] = currentStep;
    $[21] = isEditMode;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <li>In the AppFolio Developer Portal, click your profile name in the top-right corner.</li>;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <li>Click <strong>Admin</strong>.</li>;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <strong>Developer Details</strong>;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <ol>{t14}{t15}<li>Under {t16}, copy your{" "}<strong>Developer ID</strong>.</li><li>Paste it into the field below.</li></ol>;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== isEditMode) {
    t18 = <InstructionsWrapper accordion={isEditMode} title="How to find your AppFolio Database Developer ID:">{t17}</InstructionsWrapper>;
    $[27] = isEditMode;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== form || $[30] !== isCreating) {
    t19 = <FormInput autoComplete="off" disabled={isCreating} form={form} label="Developer ID" name="data.credentials.developerId" placeholder="Enter Developer ID" type="text" />;
    $[29] = form;
    $[30] = isCreating;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t13 || $[33] !== t18 || $[34] !== t19) {
    t20 = <WithCondition condition={t13}>{t18}{t19}</WithCondition>;
    $[32] = t13;
    $[33] = t18;
    $[34] = t19;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t12 || $[37] !== t20) {
    t21 = <>{t12}{t20}</>;
    $[36] = t12;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  return t21;
};
(AppFolioReportingApiProviderForm as any).providerType = ProviderType.APP_FOOLIO;
(AppFolioDatabaseApiProviderForm as any).providerType = ProviderType.APPFOLIO_DATABASE;